<template>
    <div>
        <section class="section">
            <base-delete-modal></base-delete-modal>
            <activate-license-modal
                :trans='licensing_trans'
                :actions='actions'
            ></activate-license-modal>
            <message-box></message-box>
            <div class="container">
                <h1 class="title base-list-header">
                    {{ trans.element.my_list_header }}
                </h1>
            </div>
            <div class="container is-centered">
                <div class="columns is-multiline">
                    <div
                        class="column is-3"
                        v-for="base in myBases"
                        v-if="canShowBase(base)"
                    >
                        <base-list-card :base="base"></base-list-card>
                    </div>
                    <div
                        class="column is-3"
                        :title="trans.element.import_legacy_base"
                        v-if="isShowImportFromLegacyButton"
                    >
                        <a href="#" @click="importFromLegacy">
                            <div class="card has-background-white-bis base-card create-base-card">
                                <i class="far fa-window-restore fa-4x"></i>
                            </div>
                        </a>
                    </div>
                    <div class="column is-3" :title="trans.element.create_base" v-else>
                        <a :href="actions.add" @click="addBase">
                            <div class="card has-background-white-bis base-card create-base-card">
                                <i class="fas fa-plus fa-4x"></i>
                            </div>
                        </a>
                    </div>
                </div>
                <p v-show="!myBases.length && !isShowImportFromLegacyButton">{{ trans.msg.no_admin_bases }}</p>
                <p v-show="isShowImportFromLegacyButton" class="mt-1" v-html='trans.msg.import_legacy_base'></p>
            </div>
        </section>

        <section class="section" v-if="isDefaultContext && adminBases.length > 0">
            <div class="container">
                <h1 class="title base-list-header">
                    {{ trans.element.admin_list_header }}
                </h1>
            </div>
            <div class="container is-centered">
                <div class="columns is-multiline">
                    <div class="column is-3" v-for="base in adminBases">
                        <base-list-card :base="base"></base-list-card>
                    </div>
                </div>
            </div>
        </section>

        <section class="section" v-if="isDefaultContext">
            <div class="container">
                <h1 class="title base-list-header">
                    {{ trans.element.member_list_header }}
                </h1>
            </div>
            <div class="container is-centered">
                <div class="columns is-multiline">
                    <div class="column is-3" v-for="base in memberBases">
                        <base-list-card :base="base"></base-list-card>
                    </div>
                </div>
                <p v-if="!memberBases.length">
                    {{ trans.msg.no_member_bases }}
                </p>
            </div>
        </section>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';

    export default {
        props: {
            base_list: Array,
            actions: Object,
            trans: Object,
            licensing_trans: Object,
            error: String,
        },
        data() {
            return {
                okReport: 'Показан список баз',
                hasLegacyData: bx24ImportLegacy.hasLegacyData,
                isDefaultContext: isDefaultContext,
                isAdmin24Context: isAdmin24Context,
                unblockAttachedBases: unblockAttachedBases,
            }
        },
        methods: {
            addBase(e) {
                let result = true;
                if (isBx24Context || isPortalContext) {
                    let message = this.trans.msg.base_will_be_created_in_bx24;
                    let messageData = {
                        messageText: message,
                        okText: this.trans.element.continue,
                        okCallback: () => location.href = this.actions.add,
                    };
                    this.openMessageBox(messageData);
                    e.preventDefault();
                }
                return result;
            },
            ...mapActions('baseList', [
                'addStateData',
                'setBaseList'
            ]),
            importFromLegacy(e) {
                let result = true;
                if (!isBx24Context) {
                    return result;
                }

                let message = this.trans.msg.base_will_be_imported_in_bx24;

                let messageData = {
                    messageText: message,
                    okText: this.trans.element.continue,
                    okCallback: () => {location.href = actions.legacyImport;},
                };
                this.openMessageBox(messageData);
                e.preventDefault();
            },
            canShowBase(base) {
                return !base.licensing_info.baseState.isAttached
                    || this.isDefaultContext
                    || this.unblockAttachedBases
                    || (this.isAdmin24Context && base.licensing_info.baseState.portalType !== 'admin24');
            },
            ...mapActions('messageBox', ['openMessageBox']),
        },
        computed: {
            isShowImportFromLegacyButton() {
                let needShow = this.hasLegacyData.result && isBx24Admin && config.bx24MigrationFromLegacyEnabled;
                return needShow;
            },
            ...mapGetters('baseList', {
                myBases: 'getMyBaseList',
                adminBases: 'getAdminBaseList',
                memberBases: 'getMemberBaseList',
            }),
        },
        created() {
            // Передаем список баз в хранилище vuex
            this.setBaseList(this.base_list);

            // Передаем дополнительные параметры в хранилище vuex
            let storeData = {
                actions: this.actions,
                trans: this.trans
            };

            this.addStateData(storeData);
            if (this.error) {
                let messageData = {
                    messageText: this.error,
                };
                this.openMessageBox(messageData);
            }

            sendGAEvent(this.formName);
        },
    };
</script>
